import config from 'config';
import logger from '@getgo/logger';
import loggerTargetLoggingServicePlugin from '@getgo/logger-target-logging-service';
import uuid from 'node-uuid';

const loggerTargetLoggingService = loggerTargetLoggingServicePlugin({

    server: `${config.logger.url}`,
    context: {
        ls_source: 'wdc-client',
        ls_sourcetype: 'logging'
    }
});

const appLogger = logger.createRoot(loggerTargetLoggingService);

appLogger.setContext('uuid', uuid.v4());

try {
    let machineId = window.localStorage.getItem('machineId');
    if (!machineId) {
        machineId = uuid.v4();
        window.localStorage.setItem('machineId', machineId);
    }
    appLogger.setContext('machineId', machineId);
} catch (e) {
    console.log('error', e);
}


export { appLogger };



// WEBPACK FOOTER //
// ./src/app-lib/helpers/logging.js